import type { Filter } from '@/components/table-filters/constants';
import {
  defaultRelationFilter,
  defaultStringFilter,
} from '@/components/table-filters/constants';
import {
  IndustrialPremisesQueueConfig,
  RealEstateConfig,
  SegmentConfig,
} from '@pigello/pigello-matrix';

export const industrialPremisesQueueFilters: Filter[] = [
  {
    ...defaultStringFilter,
    title: IndustrialPremisesQueueConfig.fields.name.verboseName,
    externalFieldName:
      IndustrialPremisesQueueConfig.fields.name.externalFieldName,
  },
  {
    ...defaultRelationFilter,
    title:
      IndustrialPremisesQueueConfig.fields.allowedSegmentForListing
        .verboseName,
    externalFieldName:
      IndustrialPremisesQueueConfig.fields.allowedSegmentForListing
        .externalFieldName,
    relationModelName: SegmentConfig.modelName,
  },
  {
    ...defaultRelationFilter,
    title:
      IndustrialPremisesQueueConfig.fields.requiredRealestatesForEnrollment
        .verboseName,
    externalFieldName:
      IndustrialPremisesQueueConfig.fields.requiredRealestatesForEnrollment
        .externalFieldName,
    relationModelName: RealEstateConfig.modelName,
  },
];
